import classNames from 'classnames';
import React, { Component } from 'react';

class ViewImageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { enlarged: false };
  }
  render() {
    return (
      <div data-testid="scaled-image-wrapper" className="scaled-image-wrapper --quality-check-screen-image">
        <div
          className={classNames('image-wrapper', { enlarged: this.state.enlarged })}
          onClick={() => {
            this.setState({ enlarged: !this.state.enlarged });
          }}
        >
          <img
            style={this.state.enlarged ? { left: 180, width: 150, height: 150 } : { width: 150, height: 150 }}
            title={''}
            src={this.props.imageURL}
          />
        </div>
      </div>
    );
  }
}

export default ViewImageComponent;
